import _ from 'lodash'

export const AppEntities = Object.freeze({
  USER: 'user',
  ASK: 'ask',
  POST: 'post',
  EVENT: 'event',
  EXAMINATION: 'examination',
  EXAMINATION_PAPER: 'examination_paper',
  DOCUMENT: 'document',
  ARTICLE: 'article',
  CHANNEL: 'channel',
  TOPIC: 'topic',
  KEYWORD: 'keyword',
  CATEGORY: 'category',
  UNDEFINED: 'undefined',
  PRODUCT: 'product',
  ORGANIZATION: 'organization',
  ORGANIZATION_DEPARTMENT: 'organization_department',
  CODI_DOCUMENT: 'codi_document',
  CODI_DOCUMENT_ROW: 'codi_document_row',
  LITURGY: 'liturgy',
  MUSIC: 'music',
  COURSE: 'course',
  COURSE_CLASS: 'course_class',
  COURSE_ENROLLMENT: 'course_enrollment',
  CHURCH: 'church',
  PARISH: 'parish',
  PROFILE: 'profile',
})

export const customLabels = Object.freeze({
  user: 'user',
  ask: 'q-and-a',
  post: 'post',
  event: 'event',
  document: 'document',
  article: 'articles',
  channel: 'channel',
  topic: 'topic',
  keyword: 'keyword',
  category: 'category',
  undefined: 'undefined',
  organization: 'organization',
  codi_document: 'codi document',
  codi_document_row: 'codi-document-row',
  product: 'product-service',
  masstimes: 'mass times',
  profiles: 'character',
  canon_law : 'canon law',
  vatican_ii : 'Vatican II',
  yellow_pages : 'yellow pages',
  ecclesiastic : 'document',
  definition : 'lexicon',
})

export const fromAppEntity = (type, which) => {
  let value
  switch (type) {
    case AppEntities.CODI_DOCUMENT:
      value = {
        pathname: 'codi-document',
        contextName: 'item',
        displayName: 'codi document',
      }
      break
    case AppEntities.CODI_DOCUMENT_ROW:
      value = {
        pathname: 'codi-document-row',
        contextName: 'item',
        displayName: 'lookup',
      }
      break
    default:
      value = {
        pathname: type,
        contextName: type,
        displayName: type,
      }
      break
  }

  return which ? _.get(value, which) : value
}

export const MaterialTypes = Object.freeze({
  INFO: 'info',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
})

export const LAWMessageTypes = Object.freeze({
  EMPTY: 'empty',
  ERROR: 'error',
})
